<template>
  <b-container
    class="mb-5"
    fluid
  >
    <DashboardComponent />
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import DashboardComponent from '@/components/dashboard/Dashboard.component'

export default {
  name: 'UserDashboard',
  components: {
    DashboardComponent
  },
  middleware: ['auth', 'user'],

  metaInfo () {
    return {
      title: 'User Dashboard'
    }
  },
  mounted () {
    core.index()
  }
}
</script>
